import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesComponent } from './components/messages/messages.component';
import { MessageDetailsComponent } from './components/message-details/message-details.component';
import { RouterModule } from '@angular/router';
import { ReplyComponent } from './components/reply/reply.component';
import { FormsModule } from '@angular/forms';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { InitialsPipeModule } from '../../shared/pipes/initials.pipe';
import { FormatDatePipeModule } from '../../shared/pipes/format-date.pipe';
import { RandomlyUniqueColorPipeModule } from '../../shared/pipes/randomly-unique-color-pipe';
import { MessagesService } from './services/message-service/messages.service';
import { BackButtonModule } from '../../common/back-button/back-button.module';
import { ImageModule } from '../../shared/image/image.module';
import { AuthorizationModule } from '../../authorization/authorization.module';
import { FileUploaderModule } from 'file-uploader';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PerfectScrollbarModule,
    FormsModule,
    AuthorizationModule,
    InitialsPipeModule,
    FormatDatePipeModule,
    RandomlyUniqueColorPipeModule,
    BackButtonModule,
    ImageModule,
    FileUploaderModule
  ],
  declarations: [MessagesComponent,
    MessageDetailsComponent,
    ReplyComponent],
  providers: [MessagesService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }],
  exports: []
})
export class MessagesModule { }
